export class SetMetaData {
  public static readonly type = "[RequestMetaData] Set Request Meta Data";
  constructor(public metaData: Record<string, string> | undefined) {}
}

export class ResetMetaData {
  public static readonly type = "[RequestMetaData] Clear Request Meta Data";
}
